/**
 * Message Constants
 * 
 * Centralized message definitions for consistent user-facing text
 * throughout the application
 */

// User-related fallback messages
export const USER_MESSAGES = {
  CUSTOMER_NOT_FOUND: 'Customer Not Found',
  EMAIL_NOT_AVAILABLE: 'Email Not Available',
  NAME_NOT_AVAILABLE: 'Name Not Available',
  UNKNOWN_USER: 'Unknown User'
};

// Payment-related messages
export const PAYMENT_MESSAGES = {
  PAYMENT_FAILED: 'Payment failed',
  INSUFFICIENT_FUNDS: 'Insufficient funds',
  CARD_DECLINED: 'Card declined',
  UNKNOWN_PLAN: 'Unknown Plan',
  NO_PAYMENT_METHOD: 'No payment method on file'
};

// General error messages
export const ERROR_MESSAGES = {
  SOMETHING_WENT_WRONG: 'Something went wrong',
  DATA_NOT_AVAILABLE: 'Data not available',
  LOADING_ERROR: 'Failed to load data',
  NETWORK_ERROR: 'Network connection error'
};

// Success messages
export const SUCCESS_MESSAGES = {
  PAYMENT_RETRY_SUCCESS: 'Payment retry successful',
  SUBSCRIPTION_CANCELLED: 'Subscription cancelled successfully',
  DATA_UPDATED: 'Data updated successfully',
  EXPORT_COMPLETE: 'Export completed successfully'
};

// Status messages
export const STATUS_MESSAGES = {
  NO_ISSUES: 'No Issues',
  CRITICAL: 'Critical',
  WARNING: 'Warning',
  URGENT: 'Urgent',
  UPCOMING: 'Upcoming'
};

export default {
  USER_MESSAGES,
  PAYMENT_MESSAGES,
  ERROR_MESSAGES,
  SUCCESS_MESSAGES,
  STATUS_MESSAGES
};